/**
 * Dummy data — 리뷰
 * API_DOCS: 11. 리뷰 (서비스) / 25. 관리자 - 리뷰
 *
 * ReviewResponse:
 *   id(int), reservation_id(int?), user_id(int?), username(string?),
 *   rating(int?), content(string?), is_visible(boolean), is_best(boolean), created_at(datetime)
 */

const reviews = [
  { id: 1, reservation_id: 7, user_id: 5, username: 'John Smith', rating: 5, content: '정말 최고의 서비스였습니다. 드라이버분이 친절하고 안전하게 운행해주셨어요.', service_type: 'airport', vehicle_label: '2026년 신형 스타리아 라운지 블랙', is_visible: true, is_best: true, created_at: '2025-06-10T14:00:00' },
  { id: 2, reservation_id: 1, user_id: 1, username: '김민수', rating: 4, content: '편안하고 깨끗한 차량이었습니다. 다음에도 이용하겠습니다.', service_type: 'airport', vehicle_label: '2026년 신형 스타리아 라운지 블랙', is_visible: true, is_best: false, created_at: '2025-03-22T10:30:00' },
  { id: 3, reservation_id: 2, user_id: 2, username: '이지은', rating: 5, content: '새벽 출발이었는데 정시에 도착해주셔서 감사합니다.', service_type: 'golf', vehicle_label: '2026년 신형 스타리아 라운지 블랙', is_visible: false, is_best: false, created_at: '2025-01-15T09:00:00' },
  { id: 4, reservation_id: 4, user_id: 4, username: '최유나', rating: 3, content: '서비스는 괜찮았으나 차량 내부가 약간 더웠습니다. 에어컨 조절이 되면 좋겠어요.', service_type: 'hospital', vehicle_label: '2026년 신형 스타리아 라운지 블랙', is_visible: true, is_best: false, created_at: '2024-11-08T16:00:00' },
  { id: 5, reservation_id: 5, user_id: 3, username: '박서준', rating: 2, content: '예약 시간보다 10분 늦게 도착하셨습니다. 시간 약속은 지켜주셨으면 합니다.', service_type: 'ski', vehicle_label: '2026년 신형 스타리아 라운지 블랙', is_visible: true, is_best: false, created_at: '2024-09-20T11:00:00' },
];

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/* ── 서비스 (유저용) ── */

/** GET /api/reviews/stats?service_type= */
export const getReviewStats = async (params = {}) => {
  await delay(100);
  const visible = reviews.filter((r) => r.is_visible);
  const total = visible.length;
  const totalRating = visible.reduce((sum, r) => sum + r.rating, 0);
  return {
    average_rating: total > 0 ? Math.round((totalRating / total) * 10) / 10 : 0,
    total_count: total,
  };
};

/** GET /api/reviews (query: service_type, sort, page, size) */
export const getReviews = async (params = {}) => {
  await delay(300);
  let filtered = reviews.filter((r) => r.is_visible);
  if (params.service_type) {
    // 서비스 타입 필터는 reservation 기반이므로 dummy에서는 전체 반환
  }
  if (params.sort === 'rating') {
    filtered.sort((a, b) => b.rating - a.rating);
  } else {
    filtered.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  }
  const page = params.page || 1;
  const size = params.size || 20;
  const start = (page - 1) * size;
  const totalRating = filtered.reduce((sum, r) => sum + r.rating, 0);
  return {
    items: filtered.slice(start, start + size),
    total: filtered.length,
    page,
    size,
    pages: Math.ceil(filtered.length / size),
    averageRating: filtered.length > 0 ? Math.round((totalRating / filtered.length) * 10) / 10 : 0,
  };
};

/** POST /api/reviews */
export const createReview = async (data) => {
  await delay(400);
  const newReview = {
    id: reviews.length + 1,
    reservation_id: data.reservation_id,
    user_id: 1,
    username: '더미 유저',
    rating: data.rating,
    content: data.content || null,
    is_visible: true,
    is_best: false,
    created_at: new Date().toISOString(),
  };
  reviews.push(newReview);
  return newReview;
};

/** PUT /api/reviews/:id */
export const updateReview = async (id, data) => {
  await delay(400);
  const found = reviews.find((r) => r.id === Number(id));
  if (!found) throw new Error('리뷰를 찾을 수 없습니다');
  if (data.rating !== undefined) found.rating = data.rating;
  if (data.content !== undefined) found.content = data.content;
  return found;
};

/** DELETE /api/reviews/:id */
export const deleteReview = async (id) => {
  await delay(300);
  const idx = reviews.findIndex((r) => r.id === Number(id));
  if (idx === -1) throw new Error('리뷰를 찾을 수 없습니다');
  reviews.splice(idx, 1);
  return { message: '리뷰가 삭제되었습니다' };
};

/* ── 관리자 ── */

/** GET /api/admin/reviews (페이지네이션) */
export const getAdminReviews = async (params = {}) => {
  await delay(300);
  const page = params.page || 1;
  const size = params.size || 20;
  const start = (page - 1) * size;
  return {
    items: reviews.slice(start, start + size),
    total: reviews.length,
    page,
    size,
    pages: Math.ceil(reviews.length / size),
  };
};

/** GET /api/admin/reviews/:id */
export const getAdminReviewById = async (id) => {
  await delay(200);
  const found = reviews.find((r) => r.id === Number(id));
  if (!found) throw new Error('리뷰를 찾을 수 없습니다');
  return found;
};

/** PUT /api/admin/reviews/:id/status — approved | hidden */
export const updateAdminReviewStatus = async (id, status) => {
  await delay(300);
  const found = reviews.find((r) => r.id === Number(id));
  if (!found) throw new Error('리뷰를 찾을 수 없습니다');
  found.is_visible = status === 'approved';
  return { message: '상태가 변경되었습니다' };
};
